import { primaryPalette } from '../../../../styles/theme';

export const prepareChartOptions = tooltipLabel => ({
  responsive: true,
  skipNull: true,
  maintainAspectRatio: false,
  parsing: {
    yAxisKey: 'y',
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      callbacks: {
        title: data => {
          const context = data[0];
          return `${tooltipLabel}: ${
            context.dataset.data[context.dataIndex].count
          }`;
        },
        label: data => `${data.parsed.y}%`,
      },
      titleFont: {
        family: 'ProximaNova-Bold',
        size: 14,
        lineHeight: '20px',
      },
      bodyFont: {
        family: 'ProximaNova-Regular',
        size: 12,
        lineHeight: '16px',
      },
      xAlign: 'left',
      yAlign: 'center',
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
        borderColor: primaryPalette.bluish3,
      },
      ticks: {
        display: true,
        color: primaryPalette.bluish3,
        font: {
          size: 16,
          weight: 'bold',
        },
        padding: 10,
      },
      categoryPercentage: 1.0,
      barPercentage: 1.0,
    },
    y: {
      type: 'linear',
      beginAtZero: true,
      position: 'right',
      min: 0,
      max: 100,
      grid: {
        borderDash: [4, 4],
        borderColor: primaryPalette.bluish4,
        color: primaryPalette.bluish7,
        drawTicks: false,
      },
      ticks: {
        display: true,
        color: primaryPalette.bluish3,
        font: {
          size: 10,
          weight: 'bold',
        },
        padding: 5,
      },
    },
  },
});

export const BAR_CHART_COLORS = {
  1: primaryPalette.red1,
  2: primaryPalette.red1,
  3: primaryPalette.red1,
  4: primaryPalette.red2,
  5: primaryPalette.red3,
  6: primaryPalette.red4,
  7: primaryPalette.bluish8,
  8: primaryPalette.bluish6,
  9: primaryPalette.green2,
  10: primaryPalette.green1,
};
